import { IActionCreatorAsync } from 'core/actions/Actions.interfaces'
import { ITenant } from 'reducers/Reducers.interfaces'

export interface TwoFactorAuthProps {
  account: ITenant
  updateDetails: () => void
  onCancel?: () => void
}
export interface TwoFactorAuthDispatchProps {
  enableMfa: IActionCreatorAsync
}

export enum IVerificationType {
  EMAIL_AUTHENTICATOR_APP = 'email-authenticator-app',
  CAC = 'client-authentication-certificate'
}

export type ExtendedTwoFactorAuthProps = TwoFactorAuthProps & TwoFactorAuthDispatchProps

